// extracted by mini-css-extract-plugin
export var ourErvice = "expertiseSection-module--ourErvice--2EvJ6";
export var ourErviceWrap = "expertiseSection-module--ourErviceWrap--2SKiH";
export var imgWrap = "expertiseSection-module--imgWrap--3dDZQ";
export var img = "expertiseSection-module--img--1ap9X";
export var titleAndDescription = "expertiseSection-module--titleAndDescription--w4FPI";
export var title = "expertiseSection-module--title--69t-P";
export var description = "expertiseSection-module--description--VeN_H";
export var more = "expertiseSection-module--more--5WNZ2";